import type { SelectProps } from '@ori-ui/mui';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';

import type { SelectItem } from '../types';

interface SelectFieldProps {
  readonly id: string;
  readonly value: SelectProps['value'];
  readonly onChange: SelectProps['onChange'];
  readonly items: SelectItem[];
  readonly label?: string;
  readonly placeholder?: string;
  readonly hintText?: string;
  readonly displayEmpty?: SelectProps['displayEmpty'];
  readonly disabled?: SelectProps['disabled'];
  readonly enabledReset?: boolean;
}

export const SelectField = ({
  id,
  value,
  onChange,
  items,
  label,
  placeholder,
  hintText,
  displayEmpty,
  disabled,
  enabledReset,
}: SelectFieldProps) => {
  const { getTestIdProps } = useTestId();

  return (
    <FormControl
      fullWidth
      {...getTestIdProps('select-field')}
    >
      {label ? <InputLabel htmlFor={id}>{label}</InputLabel> : null}
      <Select
        required
        id={id}
        // Value CAN'T be undefined
        value={value ?? ''}
        displayEmpty={displayEmpty}
        disabled={disabled}
        onChange={onChange}
      >
        {placeholder ? (
          <MenuItem
            disabled={!enabledReset}
            value=""
          >
            {placeholder}
          </MenuItem>
        ) : null}
        {items.map(({ Id, Text }) => (
          <MenuItem
            key={Id}
            value={Id}
          >
            {Text}
          </MenuItem>
        ))}
      </Select>
      {hintText ? <FormHelperText>{hintText}</FormHelperText> : null}
    </FormControl>
  );
};
